import React, { Component } from 'react';
import _isEqual from 'lodash/isEqual';
import cn from 'classnames';
import _noop from 'lodash/noop';
import Tooltip from '@omilia/tooltip';
import TextCropper from '@omilia/text-cropper';
import { intentType } from 'types';
import PropTypes from 'prop-types';

import Toggler from 'components/Toggler';
import ArchivedIcon from 'components/SelectableList/components/ArchivedIcon';
import ListActionsMenu from 'components/ListActionsMenu';

import './style.scss';

export default class IntentItem extends Component {
  static propTypes = {
    duplicateItem: PropTypes.func,
    isArchived: PropTypes.bool,
    isSelected: PropTypes.bool,
    model: intentType,
    toggleItemStatus: PropTypes.func,
    triggerModal: PropTypes.func,
  };

  static defaultProps = {
    isArchived: false,
    isSelected: false,
    duplicateItem: _noop,
    toggleItemStatus: _noop,
  };

  state = {
    isHovered: false,
  };

  componentWillReceiveProps({ isSelected }) {
    const { isSelected: prevIsSelected } = this.props;
    const { isHovered } = this.state;
    if (isSelected !== prevIsSelected && isHovered) {
      this.setState({
        isHovered: false,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { model, isArchived, isSelected } = this.props;
    return (
      !_isEqual(nextProps.model, model) ||
      !_isEqual(nextState, this.state) ||
      isArchived !== nextProps.isArchived ||
      isSelected !== nextProps.isSelected
    );
  }

  handleShowNav = () => {
    const { isSelected } = this.props;
    if (!isSelected) {
      this.setState({
        isHovered: true,
      });
    }
  };

  handleHideNav = () => {
    const { isSelected } = this.props;
    if (!isSelected) {
      this.setState({
        isHovered: false,
      });
    }
  };

  handleStatusChange = () => {
    const { model, toggleItemStatus } = this.props;

    toggleItemStatus(model.id, model.name, {
      enabled: !model.enabled,
    });
  };

  handleDuplicate = e => {
    const { model } = this.props;
    const { duplicateItem } = this.props;
    e.stopPropagation();

    duplicateItem(model);
  };

  render() {
    const {
      model: { id, name, xpack_resource: xpack, color, enabled },
      isArchived,
      isSelected,
      triggerModal,
    } = this.props;
    const { isHovered } = this.state;

    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    return (
      <div
        styleName={cn('item', {
          'is-archived': isArchived,
          'is-disabled': !enabled,
        })}
        onMouseEnter={this.handleShowNav}
        onMouseLeave={this.handleHideNav}
      >
        <div style={{ background: color }} styleName="item__mark" />
        <div styleName="item__name">
          <TextCropper styleName="cropper" text={name} />
          {xpack && <sup>XP</sup>}
        </div>
        <div styleName="options">
          {isArchived && <ArchivedIcon name="Intent" />}
          {!isArchived && (isSelected || isHovered) && (
            <React.Fragment>
              <div styleName="option">
                <Tooltip
                  content={
                    <React.Fragment>
                      {enabled ? 'Disable' : 'Enable'}
                      <br />
                      Intent
                    </React.Fragment>
                  }
                >
                  <div>
                    <Toggler
                      value={enabled}
                      onToggle={this.handleStatusChange}
                    />
                  </div>
                </Tooltip>
              </div>
              {!xpack && (
                <div styleName="option">
                  <Tooltip
                    content={
                      <React.Fragment>
                        Duplicate
                        <br />
                        Intent
                      </React.Fragment>
                    }
                  >
                    <span
                      className="icon-duplicate"
                      data-test="icon-duplicate"
                      onClick={this.handleDuplicate}
                    />
                  </Tooltip>
                </div>
              )}
            </React.Fragment>
          )}
          <ListActionsMenu
            items={[
              {
                name: 'Replace with',
                onClick: () => triggerModal(id),
              },
            ]}
          />
        </div>
      </div>
    );
  }
}
